__turbopack_context__.v({
  "customNumberInput": "counter-module__pRnYlW__customNumberInput",
});
